import { Button, Flex, Form, Input, Space, Typography, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import styled from 'styled-components';
import { useUpdateOrganization } from '../../api/Onboarding';

const { Text } = Typography;

const StyledForm = styled(Form)`
  max-width: 400px;
`;

function OrganizationSettings({ organization }) {
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const { mutate: updateOrganization, isLoading: updateOrganizationLoading } =
    useUpdateOrganization();

  const handleEdit = () => {
    form.setFieldsValue({
      name: organization.name,
    });
    setIsEditing(true);
  };

  const handleSave = (values) => {
    updateOrganization(
      { data: { id: organization.id, name: values.name } },
      {
        onSuccess: () => {
          message.success('Organization name updated successfully');
          setIsEditing(false);
        },
      },
    );
  };

  if (!isEditing) {
    return (
      <Flex vertical>
        <Text strong>Organization name</Text>
        <Flex justify="space-between" align="center">
          <Text>{organization.name}</Text>
          <Button onClick={handleEdit}>Edit</Button>
        </Flex>
      </Flex>
    );
  }

  return (
    <StyledForm
      form={form}
      layout="vertical"
      onFinish={handleSave}
      autoComplete="off"
      requiredMark={false}
    >
      <Form.Item
        name="name"
        label={<Text strong>Organization name</Text>}
        rules={[
          { required: true, message: 'Organization name is required' },
          { whitespace: true, message: 'Organization name cannot be blank' },
        ]}
      >
        <Input placeholder="Enter your organization name" />
      </Form.Item>

      <Space>
        <Button type="primary" htmlType="submit" loading={updateOrganizationLoading}>
          Save
        </Button>
        <Button onClick={() => setIsEditing(false)}>Cancel</Button>
      </Space>
    </StyledForm>
  );
}

OrganizationSettings.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
  }).isRequired,
};

export default OrganizationSettings;
